
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eula",
      function () {
        return require("private-next-pages/eula.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eula"])
      });
    }
  